export default "__VITE_ASSET__bcdc0e20__"